import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';

export type StoreFeedType = 'all' | 'Prop' | 'Location';
export interface StoreFilterData {
  feedType: StoreFeedType;
}

@Component({
  selector: 'app-store-filter-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonButton,
    IonButtons,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonItem,
    IonList,
    IonRow,
    IonSelect,
    IonSelectOption,
    IonTitle,
    IonToolbar,
  ],
  templateUrl: './store-filter-modal.component.html',
  styleUrls: ['./store-filter-modal.component.scss'],
})
export class StoreFilterModalComponent implements OnInit {
  private readonly modalCtrl = inject(ModalController);

  @Input() filters?: StoreFilterData | null;
  feedType: StoreFeedType = 'all';

  ngOnInit(): void {
    this.feedType = this.filters?.feedType || 'all';
  }

  apply(): void {
    this.modalCtrl.dismiss({ filters: { feedType: this.feedType } satisfies StoreFilterData });
  }

  clear(): void {
    this.modalCtrl.dismiss({ clear: true });
  }
  dismiss(): void {
    this.modalCtrl.dismiss();
  }
}
